<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid class="shift">

  <v-row>

    <v-col class="py-0">
      <div id="calendar-nav" style="width:200px;">
        <v-btn class="glyphicon glyphicon-menu-left" @click="moveLastMonth()">
          <v-icon>keyboard_arrow_left</v-icon>前月
        </v-btn>
        <v-btn class="glyphicon glyphicon-menu-right"  @click="moveNextMonth()">
          次月<v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </div>
    </v-col>

    <v-col class="py-0">
      <v-text-field
        flat
        block
        hide-details
        prepend-inner-icon="search"
        label="フリー検索"
        v-model="search"
        @change="textSearch"
        dense
      ></v-text-field>
    </v-col>

    <v-col class="py-0">
      <v-card
        class="mx-auto pt-2 pl-2"
        min-height="40px"
        outlined
      >時間数：{{jikansu}}</v-card>
    </v-col>

    <v-col class="py-0">
      <v-btn @click="kousin"><v-icon>update</v-icon>更新</v-btn>
    </v-col>

    <v-col class="py-0">
      <v-select
        v-model="type"
        :items="typeOptions"
        label="並び替え"
        @change="changeType"
        dense
      ></v-select>
    </v-col>

  </v-row>

  <v-row>
    <v-col class="ma-0 py-0">
      <p class="ym"> {{calday.year()}}年{{calday.month()+1}}月 月間シフト表</p>
      <div class="caldiv">
          <table id="calendar" class="table table-bordered">
              <thead>
                  <tr>
                      <th v-for="week in weeks" v-bind:key="week.wnm">{{week.wnm}}</th>
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="week in caldata" v-bind:key="week.day">
                      <td v-for="day in week" v-bind:key="day.id">
                        <p class="dt" v-if="day.day != ''">
                          <v-btn
                            icon
                            small
                            class="pa-0 ma-0"
                            @click="dayopen(day.dt)"
                          >{{day.day}}</v-btn>
                          <span style="color:red;font-size:90%;">{{getHoliday(day.dt)}}</span>
                        </p>
                        <template v-for="event in eventsMap[day.dt]">
                          <p
                            class="ev"
                            v-bind:class='{cancel:event.cancel, del: event.del}'
                            v-bind:style="{ color: event.color }"
                            v-bind:key="event.id"
                            @click="open(event)"
                          >{{event.title}}</p>
                        </template>
                    </td>
                  </tr>
              </tbody>
          </table>
      </div>
    </v-col>
  </v-row>

  <v-row>
    <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="600px">
      <v-card>

      <v-toolbar dense dark>
        <v-toolbar-title>シフト変更</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn @click="dialog = false">
          <v-icon>close</v-icon> 閉じる
        </v-btn>
      </v-toolbar>

        <v-card-text class="pt-5">
            <v-row>
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="ev.date"
                    label="日付を選択してください"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="ev.date" @input="menu = false" locale="ja"></v-date-picker>
              </v-menu>
            </v-row>
            <v-row>
                <v-col cols="12" xs="12" sm="6" md="4">
                  <v-select
                    v-model="ev.riid"
                    :items="riyousyas"
                    item-text="rimyoji"
                    item-value="id"
                    label="利用者"
                  ></v-select>
                </v-col>
                
                <v-col cols="12" xs="12" sm="6" md="4">
                  <v-select
                    v-model="ev.staffid"
                    :items="staffs"
                    item-text="staffname"
                    item-value="id"
                    label="担当者"
                  ></v-select>
                </v-col>
                <v-col cols="12" xs="6" sm="6">
                  <v-text-field
                    label="開始時間"
                    v-model="ev.kaisi"
                    type="time"
                    step="900"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="6" sm="6">
                  <v-text-field
                    label="終了時間"
                    v-model="ev.syuryo"
                    type="time"
                    step="900"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="6">
                  <v-select
                    v-model="ev.mark"
                    :items="services"
                    item-text="svname"
                    item-value="mark"
                    label="サービス区分"
                  ></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="6">
                  <v-select
                    v-model="ev.color"
                    :items="colors"
                    item-text="color"
                    item-value="val"
                    label="色"
                  ></v-select>
                </v-col>
              </v-row>

          </v-card-text>
          <v-card-actions>
              <v-btn outlined color="error" @click="cancel">キャンセル</v-btn>
              <v-btn outlined color="error" @click="del">削除</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="update">変更保存</v-btn>
              <v-btn outlined @click="dialog = false">
                <v-icon>close</v-icon> 閉じる
              </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row>
      <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="daydialog" width="700px">
      <v-toolbar dense dark>
        <v-toolbar-title>シフト変更</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn @click="daydialog = false">
          <v-icon>close</v-icon> 閉じる
        </v-btn>
      </v-toolbar>
        <v-card>
          <v-card-actions>
            <v-btn outlined color="success" @click="copy">コピー</v-btn>
            <v-btn outlined color="success" @click="past">貼り付け</v-btn>
            <v-btn outlined color="info" @click="add">新規追加</v-btn>
            <v-btn outlined color="info" @click="holiopen">休日追加</v-btn>
          </v-card-actions>
          <v-card-text>
                  <template>
                    <v-data-table
                      v-model="selected"
                      :headers="headers"
                      :items="dayMap"
                      item-key="id"
                      show-select
                      disable-filtering
                      disable-pagination
                      hide-default-footer
                      @item-selected="select"
                      @toggle-select-all="toggleAll"
                      mobile-breakpoint="100"
                    >
                    </v-data-table>
                  </template>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row>
      <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="holidialog" width="700px">
      <v-toolbar dense dark>
        <v-toolbar-title>休日希望</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn @click="holidialog = false">
          <v-icon>close</v-icon> 閉じる
        </v-btn>
      </v-toolbar>
        <v-card>
          <v-card-actions>
            <v-btn outlined color="info" @click="holiupdate">保存</v-btn>
          </v-card-actions>
          <v-card-text>
            <v-text-field v-model="holiday" label="休日"></v-text-field>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>



    <v-snackbar
      v-model="snackbar"
      color="success"
      :timeout=2000
    >
      {{ msg }}
      <v-btn
        @click="snackbar = false"
      >
        閉じる
      </v-btn>
    </v-snackbar>


    </v-container>
  </v-content>
</v-app>
</template>

<script>
import Auth from '@/components/Auth'
import Common from '@/components/Common'
import moment from 'moment'
export default {
  mixins: [ Common, Auth ],
  data: () => ({
    weeks: [
      { wnm: '日' },
      { wnm: '月' },
      { wnm: '火' },
      { wnm: '水' },
      { wnm: '木' },
      { wnm: '金' },
      { wnm: '土' }
    ],
    colors: [
      { color: '黒', val: 'black' },
      { color: '赤', val: 'red' },
      { color: '青', val: 'blue' },
      { color: '緑', val: 'green' },
      { color: '黄', val: 'yellow' }
    ],
    calday: '',
    caldata: [],
    keyid: 0,
    menu: false,
    daymenu: false,
    headers: [
      {
        text: '',
        align: 'start',
        sortable: false,
        value: 'name',
        width: '100px'
      },
      { text: '利用者名', value: 'riname', width: '100px' },
      { text: '開始', value: 'kaisi', width: '100px' },
      { text: '終了', value: 'syuryo', width: '100px' },
      { text: '担当者', value: 'staffname', width: '120px' },
    ],
    dayMap: [],
    copyMap: [],
    dayDt: [],
    selected: [],
    msg: '',
    snackbar: '',
    search: '',
    type: 'time',
    dialog: false,
    daydialog: false,
    holidialog: false,
    holiday: '',
    jikansu: 0,
    typeOptions: [
      { text: '時間順順', value: 'time' },
      { text: '担当者順', value: 'staff' },
      { text: '利用者順', value: 'user' },
      { text: 'サービス区分順', value: 'service' }
    ],
    events: [],
    eventsMap: [],
    holidays: [],
    staffs: [],
    riyousyas: [],
    services: [],
    ev: '',
    fullscrn: true
  }),
  computed: {
  },
  methods: {
    appbar () {
      return 'min-width:auto;'
    },
    calendar: function () {
      // 1日の曜日
      var firstDay = moment(this.calday).day()
      // 晦日の日にち
      var lastDate = moment(this.calday).daysInMonth()
      // 日にちのカウント
      var dayIdx = 1
      var day = 1
      var keyIdx = 0

      var dt = moment(this.calday)

      var calendar = []
      for (var w = 0; w < 6; w++) {
        var week = []

        // 空白行をなくすため
        if (lastDate < dayIdx) { break }

        for (var d = 0; d < 7; d++) {
          if (w === 0 && d < firstDay) {
            week[d] = { id: keyIdx, day: '' }
          } else if (w === 6 && lastDate < dayIdx) {
            week[d] = { id: keyIdx, day: '' }
            dayIdx++
          } else if (lastDate < dayIdx) {
            week[d] = { id: keyIdx, day: '' }
            dayIdx++
          } else {
            if (day > lastDate) {
              day = 1
              dt.add(1, 'months').date(1)
            }
            dt.date(day)
            week[d] = { id: keyIdx, day: day, dt: dt.format('YYYY-MM-DD') }
            dayIdx++
            day++
          }
          keyIdx++
        }
        calendar.push(week)
      }
      this.caldata = calendar
    },
    open (event) {
      if (!this.admin()) return false;
      this.dialog = true
      this.ev = event
    },
    dayopen (dt) {
      if (!this.admin()) return false;
      this.daydialog = true
      this.dayMap = this.eventsMap[dt]
      if (this.dayMap === undefined) this.dayMap = []
      this.dayDt = dt
      this.selected = this.dayMap.slice()
    },
    holiopen () {
      if (!this.admin()) return false;
      this.daydialog = false
      this.holidialog = true
      this.holiday = this.getHoliday(this.dayDt)
    },
    select(sel) {
      if (!sel.value && this.selected.includes(sel.item)) {
        this.selected = this.selected.filter(v => v !== sel.item)
      } else {
        this.selected.push(sel.item)
      }
    },
    toggleAll (sel) {
      if (sel.value) {
        this.selected = sel.items
      }
    },
    copy () {
      this.copyMap = this.selected
      this.msg = 'コピー完了しました。'
      this.daydialog = false
      this.snackbar = true
    },
    past () {
      this.msg = '貼り付け完了しました。'
      this.copyMap.forEach((v) => {
        v.ins = true
        v.cancel = false
        v.date = this.dayDt
        this.ev = v
        this.update()
      })
      this.daydialog = false
      this.selected = []
    },
    update () {
      this.dialog = false
      this.ev.staffname = this.staffs.find(staff => staff.id === this.ev.staffid).staffname
      this.ev.riname = this.riyousyas.find(ri => ri.id === this.ev.riid).riname
      var service = this.services.find(service => service.mark === this.ev.mark)
      this.ev.mark = service.mark
      this.ev.service = service.id
      this.ev.title = this.crtTitle(this.ev)
      this.ev.updid = this.$store.getters.auth.username
      var params = new FormData()
      params.append('upd', this.ev)
      var self = this
      this.$axios.post(this.url + 'updateShift.php', JSON.stringify({
        upd: this.ev
      })).then(function () {
        self.msg = '更新しました。'
        if (self.msg !== '') {
          self.snackbar = true
        }
        self.kousin()
      })
    },
    holiupdate () {
      this.holidialog = false
      var self = this
      this.$axios.post(this.url + 'updateHoliday.php', JSON.stringify({
        date: this.dayDt,
        text: this.holiday
      })).then(function () {
        self.msg = '更新しました。'
        if (self.msg !== '') {
          self.snackbar = true
        }
        self.getHolidays()
      })
    },
    cancel () {
      this.dialog = false
      this.ev.cancel = !this.ev.cancel
      this.msg = 'キャンセルに設定しました。'
      this.update()
    },
    del () {
      this.dialog = false
      this.ev.del = true
      this.msg = '削除しました。'
      this.update()
    },
    add () {
      this.daydialog = false
      this.dialog = true
      this.ev = {}
      this.ev.date = this.dayDt
      this.ev.ins = true
    },
    kousin () {
      var self = this
      this.$axios.post(this.url + 'shift.php', JSON.stringify({
        kaisi: moment(this.calday).format('YYYY-MM-DD'),
        syuryo: moment(this.calday).add(1, 'months').format('YYYY-MM-DD'),
        today: '',
        order: this.type,
        role: this.$store.getters.auth.role
      })).then(function (res) {
        self.events = res.data
        self.events.forEach((v) => {
          v.title = self.crtTitle(v)
          v.time = v.kaisi
          v.del = self.repBoolean(v.del)
          v.cancel = self.repBoolean(v.cancel)
        })
        const map = {}
        self.events.forEach(e => (map[e.date] = map[e.date] || []).push(e))
        self.eventsMap = map
        self.textSearch()
      })
    },
    crtTitle (e) {
      return this.splitBlank(e.riname) + ' ' + e.kaisi + '-' + e.syuryo + ' ' + this.splitBlank(e.staffname)
    },
    getHoliday (dt) {
      var holi = this.holidays[dt]
      if (holi) return holi
      return ''
    },
    getHolidays () {
      var self = this
      this.$axios.post(this.url + 'getHolidays.php', JSON.stringify({
        kaisi: moment(this.calday).format('YYYY-MM-DD'),
        syuryo: moment(this.calday).add(1, 'months').format('YYYY-MM-DD')
      })).then(function (res) {
        res.data.forEach((v) => {
          self.holidays[v.date] = v.text
        })
      })
    },
    getStaffs () {
      this.$axios.get(this.url + 'getStaffs.php')
        .then((response) => {
          this.staffs = response.data
        })
    },
    getRiyousyas () {
      this.$axios.get(this.url + 'getRiyousyas.php')
        .then((response) => {
          this.riyousyas = response.data
        })
    },
    getServices () {
      this.$axios.get(this.url + 'getServices.php')
        .then((response) => {
          this.services = response.data
        })
    },
    textSearch () {
      var spaceReg = new RegExp('( |　)+', 'g')
      var reg = new RegExp(this.search.replace(spaceReg, '|'))
      const map = {}
      this.jikansu = 0
      this.events.forEach((v) => {
        var text = v.riname + v.kaisi + v.syuryo + v.staffname
        if (!v.del) {
          if (reg.test(text) || text === '') {
            (map[v.date] = map[v.date] || []).push(v)
            this.jikansu = parseFloat(this.jikansu) + parseFloat(v.duration)
          }
        }
      })
      this.jikansu = Math.round(this.jikansu * 10) / 10
      this.eventsMap = map
    },
    changeType () {
      this.kousin()
    },
    splitBlank (text) {
      if (text == null) return ''
      var r = text.replace('　', ' ').split(' ')[0]
      return r
    },
    repBoolean (text) {
      if (text == null) return false
      if (text === '0') return false
      if (!text) return false
      return true
    },
    moveLastMonth: function () {
      this.keyid = 0
      this.calday.add(-1, 'months')
      this.calendar()
      this.kousin()
    },
    moveNextMonth: function () {
      this.keyid = 0
      this.calday.add(1, 'months')
      this.calendar()
      this.kousin()
    },
    formatDate: function (date, format) {
      if (!format) format = 'YYYY-MM-DD hh:mm:ss.SSS'
      format = format.replace(/YYYY/g, date.getFullYear())
      format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2))
      format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2))
      format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2))
      format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2))
      format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2))
      if (format.match(/S/g)) {
        var milliSeconds = ('00' + date.getMilliseconds()).slice(-3)
        var length = format.match(/S/g).length
        for (var i = 0; i < length; i++) format = format.replace(/S/, milliSeconds.substring(i, i + 1))
      }
      return format
    }
  },
  watch: {
    eventsMap: {
      handler: function () {
      },
      deep: true
    },
    dialog(open) {
        if (open) {
            document.body.style.top = `-${window.scrollY}px`
            document.body.style.position = 'fixed'
        } else {
            const scrollY = document.body.style.top
            document.body.style.position = ''
            document.body.style.top = ''
            window.scrollTo({top: parseInt(scrollY || '0') * -1})
        }
    }

  },
  created () {
    this.calday = moment().date(1)
    this.calendar()
  },
  mounted () {
    this.kousin()
    this.getHolidays()
    this.getStaffs()
    this.getRiyousyas()
    this.getServices()
  }
}
</script>

<style lang="stylus" scope>
  .shift {
    min-width 1500px
  }
  p.ev {
    margin: 0;
    padding: 0;
    cursor: pointer;
    font-size: 96%;
    margin-top:-2px;
  }
  p.ev:hover {
    color: red;
    font-weight: bold;
  }
  p.cancel {
    text-decoration: line-through;
  }
  p.del {
    display: none;
  }
  /* カレンダーのスタイル */
  .caldiv {
  }
  .table,
  .table th
  .table td {
    border: 1px solid gray;
  }
  .table {
    width 100%
    border-collapse: collapse;
  }
  .table th {
    padding 5px 0px
    width: 14%;
  }
  .table td {
    padding 2px 0px 2px 6px
    width: 14%;
    vertical-align: top;
  }
  .table p.dt {
    margin: 0;
  }
  p.ym {
    font-size 130%
    margin-top 3px
    margin-left 3px
  }

  #calendar th:first-child {
      background-color: #FEEEFF;
      color red
  }
  #calendar td:first-child {
      background-color: #FEEEFF;
  }
  #calendar th:nth-child(7) {
      background-color: #DFFFFF;
      color navy
  }
  #calendar td:nth-child(7) {
      background-color: #DFFFFF
  }

  #calendar td:hover {
  }


</style>
